import { scribeTrackEvent } from 'common/scribe';
import Instrumentation, {
  ALL_FACETS_PARAMS,
  EXPRESS_ACQUISITION_BANNER,
  EXPRESS_TRACKING,
  EXPRESS_TRACKING_ADD_INSTRUCTION,
} from 'scribe/constant';

// Express Tracking
const expressTracking = {
  default: ({
    trackingSource,
    isTrackingLinkExpired,
    orderIdDisplayed,
    isInApp,
    trackingPageType,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.DEFAULT,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.IS_TRACKING_LINK_EXPIRED]: isTrackingLinkExpired,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.TRACKING_PAGE_TYPE]: trackingPageType,
      },
    });
  },

  back: ({
    trackingSource,
    isTrackingLinkExpired,
    orderIdDisplayed,
    isInApp,
    trackingPageType,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.BACK,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.IS_TRACKING_LINK_EXPIRED]: isTrackingLinkExpired,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.TRACKING_PAGE_TYPE]: trackingPageType,
      },
    });
  },

  addInstruction: ({
    trackingSource,
    addInstructionPosition,
    orderIdDisplayed,
    isInApp,
    trackingPageType,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.ADD_INSTRUCTION,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.ADD_INSTRUCTION_POSITION]: addInstructionPosition,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.TRACKING_PAGE_TYPE]: trackingPageType,
      },
    });
  },

  confirmTracking: ({
    trackingSource,
    isTrackingLinkExpired,
    orderIdDisplayed,
    isInApp,
    trackingPageType,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.CONFIRM_TRACKING,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.IS_TRACKING_LINK_EXPIRED]: isTrackingLinkExpired,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.TRACKING_PAGE_TYPE]: trackingPageType,
      },
    });
  },

  copy: ({ trackingSource, orderIdDisplayed, isInApp, trackingPageType }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.COPY,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.TRACKING_PAGE_TYPE]: trackingPageType,
      },
    });
  },

  viewProof: ({
    trackingSource,
    orderIdDisplayed,
    isInApp,
    trackingPageType,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.VIEW_PROOF,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.TRACKING_PAGE_TYPE]: trackingPageType,
      },
    });
  },

  call: ({ trackingSource, orderIdDisplayed, isInApp, trackingPageType }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.CALL,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.TRACKING_PAGE_TYPE]: trackingPageType,
      },
    });
  },

  chat: ({ trackingSource, orderIdDisplayed, isInApp, trackingPageType }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.CHAT,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.TRACKING_PAGE_TYPE]: trackingPageType,
      },
    });
  },

  getSupport: ({
    trackingSource,
    orderIdDisplayed,
    isInApp,
    trackingPageType,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.GET_SUPPORT,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.TRACKING_PAGE_TYPE]: trackingPageType,
      },
    });
  },

  pay: ({
    trackingSource,
    orderIdDisplayed,
    isInApp,
    trackingPageType,
    amount,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING,
      eventName: Instrumentation.EXPRESS_TRACKING.PAY,
      facets: {
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.POD_AMOUNT]: amount,
      },
    });
  },
};

// Express Tracking Add Instructions
const expressTrackingAddInstruction = {
  default: ({
    trackingSource,
    addInstructionPosition,
    orderIdDisplayed,
    isInApp,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING_ADD_INSTRUCTION,
      eventName: Instrumentation.EXPRESS_TRACKING_ADD_INSTRUCTION.DEFAULT,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.ADD_INSTRUCTION_POSITION]: addInstructionPosition,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
      },
    });
  },

  close: ({
    trackingSource,
    addInstructionPosition,
    orderIdDisplayed,
    isInApp,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING_ADD_INSTRUCTION,
      eventName: Instrumentation.EXPRESS_TRACKING_ADD_INSTRUCTION.CLOSE,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.ADD_INSTRUCTION_POSITION]: addInstructionPosition,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
      },
    });
  },

  send: ({
    trackingSource,
    addInstructionPosition,
    orderIdDisplayed,
    isInApp,
  }) => {
    scribeTrackEvent({
      stateName: EXPRESS_TRACKING_ADD_INSTRUCTION,
      eventName: Instrumentation.EXPRESS_TRACKING_ADD_INSTRUCTION.SEND,
      facets: {
        [ALL_FACETS_PARAMS.TRACKING_SOURCE]: trackingSource,
        [ALL_FACETS_PARAMS.ADD_INSTRUCTION_POSITION]: addInstructionPosition,
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
      },
    });
  },
};

const expressAcquisitionBanner = {
  default: ({ orderIdDisplayed }) => {
    scribeTrackEvent({
      stateName: EXPRESS_ACQUISITION_BANNER,
      eventName: Instrumentation.EXPRESS_ACQUISITION_BANNER.DEFAULT,
      facets: {
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
      },
    });
  },
  click: ({ orderIdDisplayed }) => {
    scribeTrackEvent({
      stateName: EXPRESS_ACQUISITION_BANNER,
      eventName: Instrumentation.EXPRESS_ACQUISITION_BANNER.CLICK,
      facets: {
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
      },
    });
  },
  podReminder: ({ orderIdDisplayed, isInApp, amount }) => {
    scribeTrackEvent({
      stateName: EXPRESS_ACQUISITION_BANNER,
      eventName: Instrumentation.EXPRESS_ACQUISITION_BANNER.POD_REMINDER_VIEW,
      facets: {
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.IS_IN_APP]: isInApp,
        [ALL_FACETS_PARAMS.POD_AMOUNT]: amount,
      },
    });
  },
  podDownload: ({ orderIdDisplayed, amount }) => {
    scribeTrackEvent({
      stateName: EXPRESS_ACQUISITION_BANNER,
      eventName: Instrumentation.EXPRESS_ACQUISITION_BANNER.POD_DOWNLOAD_CLICK,
      facets: {
        [ALL_FACETS_PARAMS.ORDER_ID_DISPLAYED]: orderIdDisplayed,
        [ALL_FACETS_PARAMS.POD_AMOUNT]: amount,
      },
    });
  },
};

export default {
  expressTracking,
  expressTrackingAddInstruction,
  expressAcquisitionBanner,
};
